/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';

const lang = document.documentElement.lang || "en";

const closeText = {
    nl: "Sluiten",
    en: "Close",
    fr: "Fermer"
};


const GlossaryPopover = ({
    title, description, onClose,
}) => (
    <div className="glossary-popover">
        <button
            className="glossary-popover__close"
            onClick={onClose}
            type="button"
        >
            <span className="visually-hidden">{closeText[lang]}</span>
            <svg className="icon-small" viewBox="0 0 18 18" role="presentation" focusable="false">
                <use xlinkHref="#icon-close" />
            </svg>
        </button>
        <dl id={title}>
            <dt className="headline-3">{title}</dt>
            <dd className="glossary-popover__text" dangerouslySetInnerHTML={{ __html: description }} />
        </dl>
    </div>
);

GlossaryPopover.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default GlossaryPopover;
